import Divider from '@mui/material/Divider';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListSubheader from '@mui/material/ListSubheader';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import * as React from 'react';
import { MemreIcon } from './index';
import type { IconName } from './MemreIcon';

export type Item = {
  label: string;
  icon: IconName;
  onClick: () => void;
};

export type ItemGroup = {
  name?: string;
  items: Item[];
};

type Props = {
  triggerElement: React.ReactNode;
  itemGroups: ItemGroup[];
};

export default function MemreContextMenu({ triggerElement, itemGroups }: Props) {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <button
        style={{ backgroundColor: 'transparent', border: 'none', padding: 0, width: '100%' }}
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
      >
        {triggerElement}
      </button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        {itemGroups.map((group, idx) => (
          <div key={group.name}>
            {group.name && <ListSubheader>{group.name}</ListSubheader>}
            {group.items.map((item) => (
              <MenuItem
                key={item.label}
                onClick={() => {
                  handleClose();
                  item.onClick();
                }}
              >
                <ListItemIcon>
                  <MemreIcon iconName={item.icon} fontSize="0.8em" />
                </ListItemIcon>
                {item.label}
              </MenuItem>
            ))}
            {idx !== itemGroups.length - 1 && <Divider />}
          </div>
        ))}
      </Menu>
    </div>
  );
}
